module.exports = __webpack_public_path__ + "media/images/map/slide-arrow-078ba4af97aecd7534a52839b80a4304.svg";